'use client';

import { c as _c } from "react/compiler-runtime";
import { Container } from '@src/components/Container/Container';
import { type RailProps } from '@src/components/Rail/Rail.props';
import { useBreakpoints } from '@src/utils/breakpoints.util';
import { cn } from '@src/utils/tailwind';
import { RailItem } from './RailItem';
type RailGridProps = Pick<RailProps, 'items' | 'columnsDesktop' | 'columnsMobile' | 'builderBlock' | 'imageStyle' | 'slug'> & {
  isPreviewing?: boolean;
};
export const RailGrid = props => {
  const $ = _c(15);
  const {
    items,
    columnsDesktop,
    columnsMobile,
    isPreviewing,
    builderBlock,
    imageStyle,
    slug
  } = props;
  const breakpoints = useBreakpoints();
  const isMobile = breakpoints.isMobile || breakpoints.isTablet;
  const columns = isMobile ? columnsMobile : columnsDesktop;
  let t0;
  if ($[0] !== builderBlock || $[1] !== columnsDesktop || $[2] !== imageStyle || $[3] !== isPreviewing || $[4] !== items || $[5] !== slug) {
    t0 = () => items.map((t1, index) => {
      const {
        blocks
      } = t1;
      return <RailItem key={index} index={index} isPreviewing={isPreviewing} builderBlock={builderBlock} imageStyle={imageStyle} blocks={blocks} columnsDesktop={columnsDesktop ?? 1} slug={slug} />;
    });
    $[0] = builderBlock;
    $[1] = columnsDesktop;
    $[2] = imageStyle;
    $[3] = isPreviewing;
    $[4] = items;
    $[5] = slug;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  const renderItems = t0;
  let t1;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("grid gap-x-3 gap-y-6 lg:gap-8");
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const t2 = `repeat(${columns}, minmax(0, 1fr))`;
  let t3;
  if ($[8] !== t2) {
    t3 = {
      gridTemplateColumns: t2
    };
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== renderItems) {
    t4 = renderItems();
    $[10] = renderItems;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <Container><div className={t1} style={t3}>{t4}</div></Container>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};